/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Users-enns",
            "region": "us-east-2"
        },
        {
            "tableName": "ContactUs-enns",
            "region": "us-east-2"
        },
        {
            "tableName": "Field-enns",
            "region": "us-east-2"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "registerformapi",
            "endpoint": "https://5jhwlg5pw4.execute-api.us-east-2.amazonaws.com/enns",
            "region": "us-east-2"
        },
        {
            "name": "ContactUsAPI",
            "endpoint": "https://ku9m7ieryh.execute-api.us-east-2.amazonaws.com/enns",
            "region": "us-east-2"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://l6dlhh5xbe.execute-api.us-east-2.amazonaws.com/enns",
            "region": "us-east-2"
        },
        {
            "name": "AddFieldAPI",
            "endpoint": "https://q1ro5qde22.execute-api.us-east-2.amazonaws.com/enns",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:60e5eae3-01b7-43ce-9afc-8ed6dcd51e10",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_kY8YD0gf4",
    "aws_user_pools_web_client_id": "747kdr51e3ul7v8ok772p613kk",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://zjwtnj2i6rertjwbniy2edrdsq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_login_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
